import React, {useState} from 'react';
import { classNames } from 'primereact/utils';
import { useHistory } from 'react-router-dom';

const AppTopbar = (props) => {

    const history = useHistory();
    const topbarMenuClassName = classNames('topbar-menu fadeInDown', { 'topbar-menu-visible': props.topbarMenuActive });
    const profileItemClassName = classNames('user-profile', { 'active-topmenuitem': props.activeTopbarItem === 'profile' });
    const activeTopbarItemClassName = (name) => {
        return name === props.activeTopbarItem ? 'active-topmenuitem' : null;
    }
    const [currentTime, setCurrentTime] = useState(new Date());


    const isProfilePopup = props.profileMode === 'popup' || props.isHorizontal;
    const isDevEnvironment = process.env.REACT_APP_ENV === 'DEV';
    return (
        <div className="layout-topbar">
            <button className="layout-topbar-logo p-link" onClick={() => history.push('/')}>
                <img id="layout-topbar-logo" src="assets/layout/images/logo-white.png" alt="babylon-layout" />
            </button>

            <button className="layout-menu-button p-link" onClick={props.onMenuButtonClick}>
                <i className="pi pi-bars"></i>
            </button>

            <button id="topbar-menu-button" className="p-link" onClick={props.onTopbarMenuButtonClick}>
                <i className="pi pi-ellipsis-v"></i>
            </button>
            
            {isDevEnvironment ? (
                <div style={{background:"red", width:"100%", height:"100%"}}>
                    <center>
                        <span style={{fontSize:"20pt"}}>TEST ENVIRONMENT</span>
                        &nbsp;
                        <span style={{textAlign:"right"}}>version: 2025.10.15.1245</span>
                    </center>
                    
                </div>
            ):(<p style={{textAlign:"right"}}>version: 2025.10.15.1245</p>)}

            
            



        </div>
    );
}

export default AppTopbar;
